export const foldSearchText = (value: string): string =>
  value
    .normalize('NFD')
    .replace(/\p{M}/gu, '')
    .replace(/\u2212/g, '-')
    .toLowerCase()
